// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"f7154db253c90bbf797b"}[chunkId] + ".js";
};